export default "__VITE_ASSET__6RGFNYe4__"